import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import axios from 'axios';
import qs from 'qs';
// import settings from 'common/configs/setting';
import thunkMiddleware from 'redux-thunk';
import * as reducers from 'redux/reducers';
import axiosMiddleware from 'redux-axios-middleware';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { UserActions } from 'redux/actions/user';
import * as storage from 'redux-storage';
import createEngine from 'redux-storage-engine-localstorage';
import filter from 'redux-storage-decorator-filter';
import history from 'router/history';
import { asyncDispatchMiddleware } from 'redux/middlware/asyncMiddleware';
// middlwares
// axios middleware
const client = axios.create({
    // baseURL: settings.url,
    baseURL: localStorage.getItem('API_URL'),

    responseType: 'json',
    paramsSerializer: (params) => qs.stringify(params, { indicies: false })
});

// Add SU session header to v2 API requests only (v1 API has compatibility issues)
client.interceptors.request.use((config) => {
    // Try to get user from persisted Redux state or SwitchUserPage storage
    let userJson = localStorage.getItem('jrnluser');
    if (userJson) {
        try {
            const storageData = JSON.parse(userJson);
            const user = storageData.user || storageData; // Handle both formats
            // Only add SU header for v2 API endpoints
            if (user.is_su && user.su_audit_log_id && config.url && config.url.includes('/api/v2/')) {
                config.headers['X-SU-Audit-Log-ID'] = user.su_audit_log_id;
            }
        } catch (e) {
            // Ignore parse errors
        }
    }
    return config;
}, (error) => Promise.reject(error));

// Handle SU session expiry (401 responses)
client.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401 && error.response?.data?.su_session_expired) {
        // SU session has expired
        console.warn('SU session expired, forcing logout');
        
        // Clear localStorage
        localStorage.removeItem('jrnluser');
        
        // Reload to login page
        window.location.href = '/login';
    }
    return Promise.reject(error);
});

// storage middleware
const jrnlUserEngine = createEngine('jrnluser');
// persist only these state keys to localStorage
const engine = filter(jrnlUserEngine, ['user']);
export const loadStateFromStorage = storage.createLoader(engine);

const storageMiddleware = storage.createMiddleware(
    engine,
    [],
    [...UserActions]
);

// reducers
const rootReducer = combineReducers({ ...reducers, routing: routerReducer });
const reducer = storage.reducer(rootReducer);
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const errorOption = { returnRejectedPromiseOnError: true }; // option for control full .then() and .catch() functions
export const store = createStore(
    reducer,
    composeEnhancer(
        applyMiddleware(
            axiosMiddleware(client, errorOption),
            thunkMiddleware,
            routerMiddleware(history),
            storageMiddleware,
            asyncDispatchMiddleware
        )
    )
);
